export default __webpack_public_path__ + "static/media/teb.73958379.png";